module.exports = __webpack_public_path__ + "img/p2-11.b55ce3a7.png";